import createMessage from "./createMessage";
import CameraRecordingStatusBuilder from "../private/CameraRecordingStatus";

const name = "cameraVideoRecordingStatus";

function create(status: CameraRecordingStatus) {
  const payload = CameraRecordingStatusBuilder.create(status);
  return createMessage({ [name]: payload });
}

const cameraVideoRecordingStatus = { create, name };

export default cameraVideoRecordingStatus;
